<template>
  <!-- 数据大厅页面 -->
  <div class="training">
    <gat-head class="training-head"></gat-head>
    <div class="nav-head">
      <div class="nav-head-box">
        <h4>数据集大厅</h4>
        <div>
          <router-link class="go-to-dataset" :to="{ name: 'pretrain' }">
            <i class="el-icon el-icon-right"></i>
            <span>前往模型训练</span>
          </router-link>
        </div>
      </div>

      <div class="training-tab">
        <el-tabs v-model="searchType" @tab-click="handleClick">
          <el-tab-pane v-for="item in navList" :key="item.id" :label="item.label" :name="item.id"></el-tab-pane>
        </el-tabs>

        <el-button
          class="add-upload"
          type="primary"
          @click="activeCreatePopup"
        >
          <!-- <span class="icon"></span> -->
          创建数据集
        </el-button>
      </div>
    </div>
    <div class="training-area">
      <div class="training-items">
        <!-- 下拉列表、搜索查询 -->
        <div class="select-seardch-box">
          <div class="select-box">
            <el-select
              v-if="searchType == 1"
              v-model="selectType.jurisdictionType"
              placeholder="所有权限"
              @change="dropdwonChange"
              filterable
              size="small"
            >
              <el-option
                v-for="item in jurisdictionOption"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                @mouseover.native="optMouseOver"
              >
              </el-option>
            </el-select>
  
            <el-select
              v-model="selectType.datasetType"
              placeholder="全部数据类型"
              @change="dropdwonChange"
              filterable
              size="small"
            >
              <el-option
                v-for="item in datasetTypeOption"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                @mouseover.native="optMouseOver"
              >
              </el-option>
            </el-select>
  
            <el-select
              v-if="searchType == 0 || searchType == 1"
              v-model="selectType.sortType"
              placeholder="更新时间排序"
              @change="dropdwonChange"
              filterable
              size="small"
            >
              <el-option
                v-for="item in sortTypeOption"
                :key="item.id"
                :label="item.label"
                :value="item.id"
                @mouseover.native="optMouseOver"
              >
              </el-option>
            </el-select>
          </div>

          <search-box
            :placeholderName="'请输入数据集名称、行业领域'"
            :buttonShow="false" @onSearchKey="GetPageListByName"
            style="width: 300px;"
            :size="'small'"
            ref="searchKeyRef"
          ></search-box>
        </div>

        <!-- 数据集列表 -->
        <dataset-list-card
          :datasetPageType="datasetPageType"
          :searchType="searchType"
          :datasetData="datasetData"
          :searchKey="searchKey"
          @getDatasetList="getDatasetList"
          ref="datasetListcard"
        ></dataset-list-card>
        <!-- 分页 -->
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="currentPage"
            :page-size="10"
            :pager-count="5"
            layout="slot, prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- <div class="popup-list"></div> -->
  </div>
</template>

<script>
import DATASETLOBBY from "@/axios/datasetLobby/datasetLobby.js";

// import GatPopup from "@/components/common/GatPopup";
import SearchBox from '@/components/common/SearchBox.vue'
import DatasetListCard from './components/DatasetListCard.vue'

// import { DictType } from '@/assets/js/mixin/mixin.js'
// import bus from "@/utils/bus";

export default {
  // mixins: [DictType],
  name: "dataset-lobby",
  components: { 
    // GatPopup,
    SearchBox,
    DatasetListCard
  },
  // props: ["projectId"],
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传基地址
      userId: "",
      tenantId: "",
      navList: [
        {
          id: '0',
          label: '公开数据集'
        },
        {
          id: '1',
          label: '个人数据集'
        },
        {
          id: '2',
          label: '我的收藏'
        },
      ],
      searchKey: "",
      searchType: '0', // 0:公开数据;1:个人数据;2:个人收藏
      datasetPageType: 0, // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
      selectType: {
        jurisdictionType: '2', // '所有权限'
        datasetType: '0', // '全部数据类型'
        sortType: '0', // '更新时间排序'
      },
      jurisdictionOption: [
        {
          id: '2',
          label: '所有权限'
        },
        {
          id: '0',
          label: '未公开'
        },
        {
          id: '1',
          label: '已公开'
        },
      ],
      datasetTypeOption: [
        {
          id: '0',
          label: '全部数据类型'
        },
        {
          id: '1',
          label: '图像分类'
        },
        {
          id: '2',
          label: '物体检测'
        },
        {
          id: '3',
          label: '文本分类'
        },
        {
          id: '4',
          label: '文本标注'
        },
        {
          id: '5',
          label: '音频分类'
        },
        {
          id: '6',
          label: '音频标注'
        },
      ],
      sortTypeOption: [
        {
          id: '0',
          label: '更新时间排序'
        },
        {
          id: '1',
          label: '收藏数排序'
        },
        {
          id: '2',
          label: '下载数排序'
        },
        {
          id: '3',
          label: '引用数排序'
        },
        {
          id: '4',
          label: '查看数排序'
        },
      ],
      datasetData : {
        records: [],
        size: 10,
        currentPage: 1,
        total: 0
      },
      popupActive: "",
      currentPage: 1,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    totalCount() {
      return this.datasetData.total ? this.datasetData.total : 0;
    }
  },
  watch: {
    token() {
      this.GetDatasetPageList(this.searchType);
    },
    datasetData(val) {
      this.currentPage = val.current;
    },
    // beforeRouteEnter(to, from, next) {
    //   // 获取路由来源
    //   next(vm => {
    //     if (to.query.operate === "upload" && from.name) vm.activeUploadPopup();
    //   });
  },
  created() {
    this.searchType = this.$route.query.searchType || '0'
    this.userId = this.$store.state.accountInfo.userId; // 当前用户userId
  },
  mounted() {
    if (this.token) {
      this.GetDatasetPageList(this.searchType);
    }
    // let self = this;
    // bus.$on("onProgress", (percent) => {
    //   self.singleProgress = percent;
    // });
    // bus.$on("onMultiProgress", () => {
    //self.multiProgress += 10;
    //});
  },
  methods: {
    getDatasetList(pageIndex) {
      this.getDatasetPageList(pageIndex);
    },
    dropdwonChange(val) {
      this.getDatasetPageList(1);
    },
    optMouseOver(evt) {
      var target = evt.target
    },

    // 获取分页的数据集
    getDatasetPageList(pageIndex) {
      let data = {
        key: this.searchKey, // 搜索关键词(数据集名称、行业领域)
        pageNum: pageIndex || 1,
        pageSize: 10,
        searchType: this.searchType, // 0公开数据，1个人上传，2个人收藏
        status: this.selectType.jurisdictionType, // 数据集状态 0：未公开；1：已公开；2：所有
        datasetType: this.selectType.datasetType,	// 数据集类型：0全部数据类型，1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
        sort: this.searchType == 2 ? '5' : this.selectType.sortType, // 排序规则：0按时间降序，1按收藏降序，2按下载降序，3按引用降序，4按查看降序，5按收藏时间降序"
      };

      DATASETLOBBY.getDatasetHallList(data).then((result) => {
        if (result.isSuccess) {
          this.datasetData = result.data
        } else {
          this.datasetData = {
            records: [],
            size: 10,
            current: 1,
            total: 0
          }
        }
      }).catch(() => {
        this.datasetData = {
          records: [],
          size: 10,
          currentPage: 1,
          total: 0
        }
      });
    },
    // 搜索条件初始状态
    initialState() {
      this.selectType = {
        jurisdictionType: '2', // '所有权限'
        datasetType: '0', // '全部数据类型'
        sortType: '0', // '更新时间排序'
      }
      this.searchKey = ""; // 初始化搜索关键字
      this.$refs.searchKeyRef.onSearchKeyText() // 搜索关键字置空
    },
    // 数据集导航栏
    handleClick(val, event) {
      let type = val.name
      this.GetDatasetPageList(type)
    },
    // 获取数据集分页列表
    GetDatasetPageList(type) {
      this.searchType = type; // 搜索类型：0公开数据，1个人上传，2个人收藏
      // 搜索条件初始状态
      this.initialState()
      this.getDatasetPageList(1);
    },
    // 搜索获取项目分页
    GetPageListByName(key) {
      this.searchKey = key
      this.getDatasetPageList(1);
    },
    // 分页
    handleCurrentChange(pageIdx) {
      this.getDatasetPageList(pageIdx);
    },
    //  取消弹窗
    cancelPopup() {
      this.popupActive = "";
    },

    // 新建项目
    activeCreatePopup() {
      // 调用子组件创建弹窗方法
      this.$refs.datasetListcard.activeCreatePopup('create');
    },
  }
};
</script>

<style lang="scss" scoped>
@import './DatasetLobby';
</style>
